import { injectable } from "tsyringe";
import { PROVINCE_CONFIGURATION } from "api/ApiPath";
import client from "api/client";
import { IProvinceConfigurationRepository } from "../domain/repositories/IProvinceConfigurationRepository";
import { ProvinceConfigurationListRequestModel } from "./model/ProvinceConfigurationListRequestModel";
import { ProvinceConfigurationFormRequestModel } from "./model/ProvinceConfigurationFormRequestModel";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { ProvinceConfigurationResponseEntity } from "../domain/entities/ProvinceConfigurationResponseEntity";

@injectable()
export class ProvinceConfigurationImpl implements IProvinceConfigurationRepository {
  async getList(
    params: ProvinceConfigurationListRequestModel,
  ): Promise<ListBaseApiResponseModel<ProvinceConfigurationResponseEntity>> {
    return await client.get(PROVINCE_CONFIGURATION.LIST, params);
  }

  async getDetail(params: {
    id: string;
  }): Promise<BaseApiResponseModel<ProvinceConfigurationResponseEntity>> {
    return await client.get(PROVINCE_CONFIGURATION.DETAIL, params);
  }

  async create(
    body: ProvinceConfigurationFormRequestModel,
  ): Promise<BaseApiResponseModel<ProvinceConfigurationResponseEntity>> {
    return await client.post(PROVINCE_CONFIGURATION.CREATE, body);
  }

  async update(
    body: ProvinceConfigurationFormRequestModel,
  ): Promise<BaseApiResponseModel<ProvinceConfigurationResponseEntity>> {
    return await client.put(PROVINCE_CONFIGURATION.UPDATE, body);
  }

  async delete(params: {
    id: string;
  }): Promise<BaseApiResponseModel<ProvinceConfigurationResponseEntity>> {
    return await client.delete(PROVINCE_CONFIGURATION.DELETE, params);
  }
}
